import { Dialog } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Download, X, Calendar, User, Smartphone, Hash } from "lucide-react";
import { useRef } from "react";

const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiBackdrop-root": {
    backdropFilter: "blur(6px)",
    backgroundColor: "rgba(0, 0, 0, 0.2)",
  },
  "& .MuiPaper-root": {
    borderRadius: 12,
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    // overflow: "visible",
    maxWidth: "500px",
    width: "100%",
  },
}));

export default function OrderReceipt({ order, open, onClose }) {
  const receiptRef = useRef(null);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return {
      date: date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' }),
      time: date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' }),
    };
  };

  const { date, time } = formatDate(order?.createdAt);

  const printReceipt = () => {
    const printContent = receiptRef.current.innerHTML;
    const originalContent = document.body.innerHTML;

    document.body.innerHTML = printContent;
    window.print();
    document.body.innerHTML = originalContent;
    window.location.reload();
  };

  return (
    <StyledDialog open={open} onClose={onClose}>
      <div className="p-4">
        <div className="flex justify-between items-center border-b pb-2">
          <h2 className="text-xl font-semibold text-gray-800">Order Receipt</h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
            <X size={24} />
          </button>
        </div>

        <div ref={receiptRef} className="p-6 bg-white">
          <div className="text-center mb-6">
            <div className="flex justify-center mb-2">
              <div className="w-24 h-auto bg-red-100 rounded-full flex items-center justify-center">
                <img
                  className="dark:hidden w-auto h-[40px]"
                  src="/images/afh-logo.png"
                  alt="Logo"
                  width={140}
                  height={40}
                />
              </div>
            </div>
            <h1 className="text-2xl font-bold text-gray-800">YES Charge </h1>
            <p className="text-gray-600">Order Receipt</p>
          </div>

          <div className={`text-center py-2 px-4 rounded-full mb-6 ${
            order?.status === 'succeeded'
              ? 'bg-green-100 text-green-800'
              : order?.status === 'failed'
              ? 'bg-red-100 text-red-800'
              : 'bg-yellow-100 text-yellow-800'
          }`}>
            {order?.status?.toUpperCase()}
          </div>

          <div className="space-y-4 ">
            <div className="flex justify-between items-center">
              <div className="flex items-center text-gray-600">
                <Hash size={15} className="mr-2" />
                <span className="text-[15px]">Transaction ID</span>
              </div>
              <span className="font-mono text-[15px] text-gray-800">{order?.txnNumber}</span>
            </div>

            <div className="flex justify-between items-center">
              <div className="flex items-center text-gray-600">
                <Calendar size={16} className="mr-2" />
                <span className="text-[15px]">Date & Time</span>
              </div>
              <div className="text-right">
                <div className="text-gray-800 text-[15px]">{date}</div>
                <div className="text-sm text-gray-600">{time}</div>
              </div>
            </div>

            <div className="flex justify-between items-center">
              <div className="flex items-center text-gray-600">
                <User size={16} className="mr-2" />
                <span className="text-[15px]">Receiver</span>
              </div>
              <span className="font-medium text-[15px] text-gray-800">{order?.receiver}</span>
            </div>

            <div className="flex justify-between items-center">
              <div className="flex items-center text-gray-600">
                <Smartphone size={16} className="mr-2" />
                <span className="text-[15px]">Operator</span>
              </div>
              <span className="font-medium text-[15px] text-gray-800">{order?.operator}</span>
            </div>

            <div className="border-t pt-4 mt-4">
              <div className="flex justify-between items-center text-lg font-bold">
                <span className="text-gray-800">Amount</span>
                <span className="text-red-600">{order?.amount} {order?.currency}</span>
              </div>
            </div>
          </div>

          <div className="text-center text-sm text-gray-500 border-t pt-4">
            <p>Thank you for using YES Charge </p>
            <p>For support: support@yes-charge.com</p>
          </div>
        </div>

        <div className="flex justify-center ">
          <button
            onClick={printReceipt}
            className="flex items-center px-4 py-2 bg-primary text-white rounded-md hover:bg-[#df2323]"
          >
            <Download size={16} className="mr-2" />
            Print Receipt
          </button>
        </div>
      </div>
    </StyledDialog>
  );
}